import { __assign, __awaiter, __generator, __spreadArray } from "tslib";
import { transformToNestObject } from 'react-hook-form';
// This helper method basically transforms yup validation errors into
// an error object that react-hook-form understands.
// It converts an array of errors into an object, keyed by path:
// ```
//  [{path,message,type}] => {[path] => {message, type}}
// ```
// By default it will return only a single error type per path (since we're
// mostly interested in showing one field error at a time and we can bail on
// other failed validations), but it can optionally return all the error types
// for every field path.
var parseErrorSchema = function (error, validateAllFieldCriteria) {
    var _a;
    return Array.isArray(error.inner) && error.inner.length
        ? error.inner.reduce(function (previous, _a) {
            var _b, _c;
            var path = _a.path, message = _a.message, type = _a.type;
            var previousTypes = (previous[path] && previous[path].types) || {};
            return __assign(__assign({}, previous), (path
                ? (_b = {},
                    _b[path] = __assign(__assign({}, (previous[path] || {
                        message: message,
                        type: type,
                    })), (validateAllFieldCriteria
                        ? {
                            types: __assign(__assign({}, previousTypes), (_c = {}, _c[type] = previousTypes[type]
                                ? __spreadArray(__spreadArray([], [].concat(previousTypes[type]), true), [message], false) : message, _c)),
                        }
                        : {})),
                    _b) : {}));
        }, {})
        : (_a = {},
            _a[error.path] = { message: error.message, type: error.type },
            _a);
};
export var yupResolver = function (schema, options) {
    if (options === void 0) { options = {
        abortEarly: false,
    }; }
    return function (values, context, validateAllFieldCriteria) {
        if (validateAllFieldCriteria === void 0) { validateAllFieldCriteria = false; }
        return __awaiter(void 0, void 0, void 0, function () {
            var e_1, parsedErrors;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        if (options.context &&
                            process.env.NODE_ENV === 'development') {
                            // eslint-disable-next-line no-console
                            console.warn("You should not used the yup options context. Please, use the 'useForm' context object instead");
                        }
                        _a = {};
                        return [4 /*yield*/, schema.validate(values, __assign(__assign({}, options), { context: context }))];
                    case 1: return [2 /*return*/, (_a.values = (_b.sent()),
                            _a.errors = {},
                            _a)];
                    case 2:
                        e_1 = _b.sent();
                        parsedErrors = parseErrorSchema(e_1, validateAllFieldCriteria);
                        return [2 /*return*/, {
                                values: {},
                                errors: validateAllFieldCriteria
                                    ? parsedErrors
                                    : transformToNestObject(parsedErrors),
                            }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
};
export default yupResolver;
//# sourceMappingURL=yupResolver.js.map